export default "/profile/images/tiktok.svg?9c5b86c98ff79276f95a41ee7f926408";